module.exports = {
  businessNumber: '取引番号（業務No.）',
  businessType: '取引タイプ ',
  mblNo: 'マスタコード',
  customer: '顧客',
  carrier: 'キャリア名',
  vessel: '船名',
  shippingCompanyContractNo: '船会社契約番号',
  voyageFlight: '便名（フライト）',
  portOfLoading: '積出港／出発港',
  SeaPortOfLoading: '積出港／積込港（海港）',
  AirportOfLoading: '積出空港',
  portOfDestination: '到着港',
  dischargingPortCode: '揚げ港',
  dateOfDeparture: '就航日',
  businessDate: '取引日',
  businessReferenceNumber: '参照番号',
  bookingAgent: '予約代理店',
  dateOfCreation: '作成日',
  dateOfProof: '証憑日付',
  operation: '操作内容',
  sales: '売上金額',
  salesDepartment: '営業部門名',
  CustomerService: 'カスタマーサービス担当',
  Documents: '関連書類',
  accrued: '計上済',
  status: '処理状況',
  actualChargedWeight: '実請求重量',
  profit: '利益',
  totalIncome: '総売上／総収益',
  totalCost: '総コスト',
  closingAccountStatus: '繰越状態',
  hasReceivable: '繰り越しを強製するかどうか',
  profitExcludingTax: '利益（税抜き）',
  totalIncomeExcludingTax: '所得（税抜き）',
  totalCostExcludingTax: '原価（税抜き）',
  profitClosingAccount: '繰越利益剰余金',
  totalIncomeClosingAccount: '繰り越される収益',
  totalCostClosingAccount: '繰越原価',
  hasReceivableTotal: '強製的に計上するかどうか',
  profitCommission: '今回の歩合利益',
  totalIncomeCommission: '今回の歩合収入',
  totalCostCommission: '今回の取得原価',
  provisionedStatus: '見越状態',
  refundCommission: 'コミッション',
  closingAccountRevenue: '繰り越された収益',
  closingAccountCost: '繰り越されたコスト',
  invoiceCost: '請求されたコスト',
  payablesWriteOfStatus: '未払消込処理状況',
  receivablesWriteOfStatus: '売掛消込状況',
  payablesConfirmOfStatus: '費用対応確認状況',
  receivablesConfirmOfStatus: '売掛確認済',
  accrualDate: '計上日',
  creator: '取引登録者',
  receivables: '売掛金',
  payables: '買掛金',
  englishDescriptionOfGoods: '英語品名',
  chineseDescriptionOfGoods: '中国語品名',
  consignationCompany: '委託先コード／名称',
  settlementCompany: '会計単位',
  destinationAgent: '仕向地代理店',
  nominatedAgent: '指定フォワーダー',
  destinationAgentShortName: 'Destination agent short name',
  nominatedAgentShortName: 'Nominated agent short name',
  containerNo: '箱番号',
  amountRange: '金額範囲',
  profitRange: ' 利益区分',
  localAmountRange: '本位通貨金額範囲',
  SubmissionDateTime: 'データ送信日時',
  AuditDateTime: '監査時間',
  feeStatus: '費用処理状況',
  redChargesOrNot: '赤沖かどうか',
  seaportOfDischarge: '揚げ地（港）（海港）',
  airportOfDischarge: '揚げ地（港）（空港）',
  airportOfDestination: '仕向空港',
  operationDepartment: '操作部門',
  invoiceDate: '請求日',
  invoiceDateAR: '入金請求日',
  financialaDate: '会計処理日',
  solicitationType: '集荷種別',
  warehouseNo: '入庫番号',
  itemNo: 'プロジェクト番号',
  receivablesInvoicingStatus: '請求処理状況',
  receivablesInvoicingStatusAr: '受取請求書処理状況',
  businessStatus: 'ビジネス処理状況',
  customJobType: 'カスタム取引タイプ ',
  separateNumber: 'セクション番号',
  containerDescription: '箱数説明',
  designationAgent: '指定貨物代理店',
  masterBLFreightTerm: 'マスター運賃条件',
  HBLFreightClause: '個別運賃条項',
  IncoTerm: '取引条件',
  FLCLType: 'フルタイプ',
  SeaExportFLCLType: '統合タイプ（海上輸出）',
  SeaImportFLCLType: '統合タイプ（海上輸入）',
  OperateType: '操作モード',
  AirExportOperateType: 'モード（航空）',
  AirImportOperateType: '操作モード（航空輸入）',
  UserDefinedField1: 'カスタムフィールド1',
  UserDefinedField2: 'カスタムフィールド2',
  UserDefinedField3: 'カスタムフィールド3',
  ManageAuditStatus: '利益監査処理状況',
  paymentRequestNumber: '支払請求番号',
  placeOfDelivery: '納品先',
  changeState: 'ステータス変更履歴',
  grossProfitRate: '粗利率',
  railwayTransportLine: '鉄道ルート',
  route: '航路コード／航路名',
  exportLoadingPlan: 'パレット計画のエクスポート',
  exportSalesReport: '売上レポートのエクスポート',
  moreOperations: 'その他の操作',
  routeOperation: '航路操作',
  completeBooking: '予約済み',
  warehousing: '倉庫に入る',
  mountingBoard: 'ボードを装着する',
  pullGood: '荷物を引っ張る',
  applicationForFlightAdjustment: 'フライトの調整を申請する',
  allocateFlights: 'フライトの配車',
  confirmCabinAllocation: '配船を確認する',
  cancelConfirmationOfCabinAllocation: '配室の確認をキャンセルします',
  copyIncomingData: '倉庫データをコピーします',
  otherRemarks: 'その他のコメント',
  otherExpenses: 'その他の費用',
  delivery: '納品',
  deliveryAgent: '配送エージェント',
  uploadBoardPhotos: 'ボード写真のアップロード',
  subLabel: 'ラベル付け',
  prefabricatedMasterOrder: '事前に作成されたマスターオーダー',
  prefabricationOrderSplitting: 'プレファブリケーションオーダー',
  printMasterOrder: 'マスタを印刷します',
  printSplit: '分割シートを印刷する',
  track: '追跡する',
  takeOff: '離陸',
  arrival: '港に着く',
  Discharge: '船を降ろす',
  billOfLadingInquiry: '船荷証券照会',
  expandAll: 'すべて展開',
  putItAllAway: 'すべて閉じる',
  noBusinessFlight: 'ビジネスフライトなし',
  heavy: '重い',
  takeOff2: '離陸しました',
  arrivedAtPort: '到着しました',
  size: 'サイズ',
  cabinAllocationStatus: '配船状態',
  installationInstructions: 'インストール手順',
  photograph: '写真を撮る',
  guanFeng: '閉じます',
  singleCopy: '連結リスト',
  flightInformationEmpty: 'フライト情報が空です。',
  lockFlight: 'フライトをロックする',
  unlockFlight: 'フライトのロックを解除する',
  cabinAllocationStatusConfirmed: 'チケット業務の配室状態は確認済みに設定されていますか？',
  confirmationSucceeded: '成功を確認しました！',
  confirmThis: 'これを確認します',
  cabinAllocationStatusUnconfirmed: 'チケット業務の配室状態は未確認に設定されていますか？',
  hair: '毛',
  selectBookedOrder: '予約するシートを選択してください！',
  preprint: 'プレプリント',
  undoPrinting: '印刷を取り消します',
  temporaryStorage: '一時保存',
  bookingNumber: 'ブッキング番号',
  bookingTime: '予約時間',
  descriptionOfBookingResults: '予約結菓の説明',
  declared: '通関済み',
  enterDeliveryAgent: '配送エージェントを入力してください。',
  whetherTakePhotos: '写真を撮るかどうか',
  siteRemarks: 'フィールドノート',
  otherInstructions: 'その他の説明',
  enterBillOfLadingNumber: '荷受証番号を入力してください。',
  takeoffTime: '離陸時間',
  deliveryTime: '納品時間',
  trackingFlight: 'フライトを追跡する',
  trackingArrival: '到着港を追跡する',
  trackingDelivery: '配送の追跡',
  enterDepartureTime: '離陸時間を入力してください。',
  enterArrivalTime: '到着時刻を入力してください。',
  enterDeliveryTime: '納品時間を入力してください。',
  receivingOutsideWarehouse: '入荷（外部倉庫）',
  warehousingTime: '倉庫に入る時間:',
  damagedAndDamp: '破損や湿気がある',
  photo: '写真',
  selectPhotos: '写真を選択する',
  deletePhotos: '写真を削除する',
  selectWarehousingDate: '入庫日を選択してください！',
  enterSubLabel: '入力サブラベル',
  receiptNo: '返信番号',
  pleaseEnterSubLabel: 'サブラベルを入力してください.',
  uploading: 'アップロード中',
  oneFileVolumn2MB: '2MBを超えるファイルが1つあり、アップロードできません。',
  failedDeleteFile: 'ファイルの削除に失敗しました！',
  uploadSucceeded: 'アップロードに成功しました',
  uploadFailed: 'アップロードに失敗しました',
  uploadComplete: 'アップロードに失敗しました',
  notExceed6Lines: '最大6行まで！',
  line: '線路',
  airTransportArea: '空輸エリア',
  operationalResponsibilities: '操作責任',
  assignmentOfResponsibilities: '役割の割り当て',
  roleList: 'ロールリスト',
  assignedResponsibilities: '役割が割り当てられました',
  listOfResponsibilities: 'ロールリスト',
  NoVoucherGeneratedReceivable: '買掛伝票の売掛金生成済',
  NoVoucherGeneratedPayable: '買掛伝票未生成',
  VoucherGeneratedReceivable: '買掛伝票の売掛金が生成された',
  VoucherGeneratedPayable: '買掛伝票生成済',
  TenTicketsAtTheSameTime: '最大10チケットサービスを同時に表示できます。もう一度選択してください。',
  DataChangedToReopen: 'データが変更されました。再度開いて編集してください。',
  JobOpenedAndCannotDelete: 'このチケット業務はすでに新しいタブを開いているので、削除できません！',
  AreWantToDeleteBusiness: 'このチケットビジネスを削除しますか？',
  DoToDeleteTheTicket: 'レシートを削除しますか？',
  AreToDeleteTheBusiness: '現在選択されているビジネスを削除しますか？',
  AreToConvertTheItem: '現在選択されている項目を変換しますか？',
  ConversionSucceeded: '変換が成功しました',
  OperationDepartmentCannotBeEmpty: 'オペレーション部門は空にできません！',
  OrangeWorkingDaysFromETA: 'オレンジ:ETAから7営業日以内',
  RedWorkingDaysFromETA: '赤:ETAから3営業日以内',
  BatchOfWholeSplicingType: '一括修正スペルタイプ:',
  UploadedOnlyBeInFormat: 'アップロードされたファイルはcsv形式のみです！',
  ThatSOk: '行',
  NotInPositiveOperation: '正の動作状態ではありません.',
  AreTicketsSubmitted: 'チケットは提出しますか？',
  IsTheTicketPreSubmitted: 'チケットリストは事前に提出しますか？',
  AreWantToWithdrawTicket: 'このチケットをキャンセルしますか？',
  BillOfLadingInformationTracking: '船荷証券情報追跡',
  PleaseMaintainTheJumpAddress: 'ジャンプアドレスを維持してください！',
  CannotBeEmpty: '空にできません',
  AreWantToRemoveTicket: '本当にこのチケットを削除しますか？',
  NoBusinessSelected: 'ビジネスが選択されていません',
  IfForTheGoodsSame: '本券貨物が海外代理同船会社の契約価格を使用する場合は、ここにチェックを入れます',
  EspeciallyPeersThatUBISpace: 'UBIが予約した船会社または同業者を指す',
  UnitKg: '単位:キログラム',
  UnitCubicMeter: '単位:立方メートル',
  UnitTon: '単位:トン',
  DoorNotBeenSavedPrinted: '保存されていないゲートポイント情報は印刷できません！',
  CaseNo: '箱番号は',
  AllTheAssociationDoContinue: 'のデータはすべて削除されます。続行しますか？',
  DetailsSeaborneExportGoodsXls: '海運輸出貨物明細.xls',
  FindTheTrailerLocationNow: 'トレーラーの場所を今すぐ検索する',
  EstimatedLoadingDate: 'ロード予定日',
  SelectDateAndTime: '日時を選択',
  PrimaryDocNoAlreadyExists: 'マスタ番号は既に存在します',
  PleaseEnterTheFlightNumber: 'フライトナンバーを入力してください。',
  PleaseEnterETD: 'ETDを入力してください.',
  PleaseEnterAnAction: '操作内容を入力してください。',
  PleaseEnterTheRoute: '航路を入力してください.',
  AreWantToAllocateFlight: 'この【{0}】チケット業務のフライトを配車しますか？',
  DeploymentSucceeded: 'プロビジョニングが成功しました！',
  SuccessfullyPicturesAreYouSave: 'アップロード成功:{0}個、失敗:{1}個の画像、保存しますか？',
  TheSelectedRecordMustSame: '選択したレコードのETDは同じでなければなりません！',
  TheSelectedRecordsMustSame: '選択したレコードの航空会社は同じでなければなりません！',
  PleaseWithTheSameMode: '動作モードが一緻する業務を選択してください',
  SiruiPleaseContactTheTroubleshooting: '思鋭依頼書のプッシュに失敗しました。スタッフに連絡して調査してください',
  BusinessTodayIsNotCustoms: '出航日が今日より大きい業務は通関できません',
  G7DataPush: 'G7データプッシュ',
  DropDown: 'ドロップダウン',
  TheBeenAddedToOrder: 'サブオーダーがメインオーダーに追加されました！',
  NotBoundYet: 'まだバインドされていません！',
  TheCostSharingAndSeparated: '現在のレシートには割り勘料金があり、分離できません！',
  AreUnbindTheMasterOrder: 'マスターチケットまたはマスターオーダーとのバインドを解除しますか？',
  PleaseEnterOperatorInformation: 'オペレータ情報を入力してください！',
  TheIsIllegalPleaseEnter: 'マスタ番号が有効ではありません。再入力してください！',
  PleaseTheDesignatedShippingAgent: '指定した貨物代理を入力してください！',
  TheseWillBeSetJoin: 'これらのフィールドはマスタチケットとは異なります。マスタチケットに参加する場合はマスタチケットと同じに設定されます。参加しますか？',
  TheNotExceed6Lines: '最大6行まで！',
  TheNotExceed7Lines: '最大7行まで！',
  ThereMasterTicketThisPerformed: 'マスタチケットには料金があるので、この操作はできません！',
  TheTicketIfYouSwitch: 'チケットはすでにメインチケットにバインドされており、メインチケットの下には1つのチケットしかありません。操作モードを切り替えると、メインチケットは削除されます！切り替えますか？?',
  TheTheBindingRelationshipSwitch: 'レシートはすでにメインチケットとバインドされており、操作モードを切り替えるとメインチケットとのバインド関係が解除されます！切り替えますか？?',
  SwitchAMasterTicketSwitch: '一主多分動作モードに切り替え、システムは自動的に一枚の主チケットを作成して現在のチケットとバインディングします！切り替えますか？?',
  DateExceededCreditControl: 'パートナーの会計期間が超過しました！',
  AmountExceededCreditControl: 'パートナークォータが超過しました！',
  DateAndAmountExceededCreditControl: 'パートナークォータの会計期間が超過しました！',
  ThisHasExceededCreditControl: 'このパートナーは信頼できません',
  ItAEntrustingUnitAgent: '委託先または指定貨物代理としてはいけません',
  ThisHasBeenAutomaticallyCleared: 'このバーは自動的にクリアされました',
  JoinTheTicketSuccessfully: 'チケットを追加しました！',
  ThereSplitTicketTheTicket: '現在のメインチケットにはサブチケットが1つしかありません。サブチケットを移動すると、メインチケットは自動的に削除されます。本当にサブチケットを移動しますか？',
  TheTicketHasBeenRemoved: 'メインチケットは削除されました！',
  AreRemoveThisSubTicket: 'このサブチケットをメインチケットから削除してもよろしいですか',
  AttachmentDescription: '添付ファイルの説明',
  AirlineCachePleaseResetAgain: 'キャッシュに航空会社情報が見つかりませんでした。キャッシュをリセットしてみてください',
  ResettingTheModifiedContentContinue: '初期値をリセットすると変更された内容が上書きされます。続行しますか？',
  PleaseEnterTheSplitNumber: '注文番号を入力してください',
  AlreadyExists: '既に存在します！',
  DetailsAirExportGoodsXls: '空輸輸出貨物明細.xls',
  PleaseSelectWarehousingData: '倉庫データを選択してください！',
  AreToDeleteThisData: '本条の倉庫データを削除しますか？',
  TheRateMAndAdjusted: 'TOTAL値がメンテナンスされた運賃Mより小さいため、運賃関連情報を調整できません！',
  AirlineInformation: '航空会社情報',
  PleaseSelectAFee: '料金を選択してください',
  SelectMainOrder: 'メインシートを選択',
  ManualInput: '手動入力:',
  TheOrderNumberIsIllegal: 'マスタ番号が不正です！',
  WarehousingInstructions: '倉庫に入る説明',
  OtherInstructions: 'その他の説明:',
  GoodsIntoThisWarehouse: '本倉に入荷します',
  NeedPhotos: '写真が必要です',
  AttachedDocuments: 'ランダムファイルを添付します',
  Generate: '生成する',
  Save: '保存しますか？',
  PleaseTheEstimatedWarehousingTime: '予想倉庫時間を入力してください！',
  AirlineCompany: '航空会社:',
  Flight: 'フライト:',
  FieldOperation: 'フィールドオペレーション:',
  SendFieldOperation: 'フィールド操作を送信する',
  EntrustedWeight: '委託重量',
  NumberOfBookingPieces: '予約件数',
  BookingWeight: '予約クラスの重量',
  BookingVolume: '予約ボリューム',
  PleaseFillInTheFlight: 'フライトを記入してください！',
  PromissoryHaveBecomeOfficialBusiness: '約束手形はすでに正式な業務です。',
  ThisApprovalStatusAndEdited: 'このシートは財務承認状態になっているので、編集できません。',
  AreToConvertTheItem2: '現在選択されている項目を変換しますか？',
  TheDoesNotComplyRules: 'マスタ番号が規則に適合しません！',
  DoubleOfLadingHeaderUp: '船荷証券のヘッダをダブルクリックしてポップアップします',
  SmallNumberOfVotes: '小票数',
  NumberOfPrimaryVotes: '投票数',
  ThePleaseMaintainTheFirst: 'マスタ番号が空です。マスタ番号を維持してください',
  TheTheNewlySelectedContinue: '新しく選ばれたチケットのフライトナンバー、航空会社、出発日、到着日、メインリストの出荷方法とメインリストの運賃条項はメインリストと一緻しません。システムはレシートを修正します。続行しますか？',
  ClickSelectTheGoodsCode: 'スペースをタップして貨物大類CODEを選択',
  AreSureVoidThisTicket: 'このチケットをキャンセルしますか？',
  AllChargesBeDeleted: 'すべての費用が削除されます！',
  SellingPriceCalculationCompleted: '売値計算完了',
  OperationOfTicketCannotEdited: 'あなたはこのチケットのオペレータではないので、編集できません。',
  ActualNotifierCannotBeBlank: '実際の通知先は空にできません',
  SpecifiedFreightAgentCannotEmpty: '指定された貨物エージェントは空にできません',
  ArrivalDateCannotBlank: '到着日は空にできません',
  OperationDepartmentCannotBlank: '操作内容部門は空にできません',
  ExpectedArrivalDateCannotBlank: '到着予定日は空にできません',
  PleaseReselect: '選択し直してください',
  EstimatedProfitNotCompanyRegulations: '約束手形業務の予想利益が会社の規定{0}の間に合わない場合、保存を確認しますか？',
  ReceivableExpensesMustBeEntered: '売掛金は入力する必要があります。',
  PayableExpensesMustBeEntered: '買掛金は入力する必要があります。',
  BlockedCannotUsedContactCustomerManagement: '【{0}】はブロックされているため使用できません。当社の顧客管理者に連絡してください。',
  CompanyBlockedCannotUsedWithReason: '【{0}】はブロックされています。停用理由：【{1}】',
  CompanyBlockedCannotUsed: '【{0}】はブロックされています。',
  exportOption: 'エクスポートオプション',
  exportDescription: '説明をエクスポートします',
  dataNotMerged: 'データはマージされません',
  noMoreReminders: '再通知しない',
  UsCustomsClearance: 'アメリカのクリアランス',
  CustomerInformation: 'お客様の情報',
  DeclarationMaterials: '申告資料',
  TopSecretInformation: '極秘資料',
  DeletionIsUnrecoverable: '削除操作は回復できません。データを削除してもよろしいですか？',
  PleaseEnterOnLine: '{0}行目の{1}を入力してください',
  CustomerName: 'Customer name',
  CustomsClearanceProductName: 'クリアランス名',
  NumberOfPackages: 'パッケージ数',
  NumberOfGoods: '貨物件数',
  CustomsClearanceUnit: 'クリアランスユニット',
  Export7501: 'エクスポート7501',
  ExportInvoicePackingList: '請求書パックリストのエクスポート',
  GenerateReceivableExpense: '売掛金を生成する',
  GeneratePayableExpenses: '買掛金を生成',
  CopyAsCustomerData: '顧客データとしてコピー',
  CopyAsDeclarationData: '申告資料としてコピーします',
  CopyAsTopSecretInformation: '極秘資料としてコピーします',
  PdfType: 'PDFタイプ',
  MergeProductNamesWhenFiles: 'ファイル生成時に同品名をマージする',
  ShowTax: '税金を表示します',
  ShowChinaSurtax: '中国の付加税を表示します',
  ShowMargin: '保証金を表示します',
  MarginAmount: 'マージン金額',
  TotalNetWeight: '正味重量合計',
  TotalValue: '合計値',
  TotalTariff: '関税合計',
  TotalOtherExpenses: 'その他の費用合計',
  UnitWeight: '単品の重量',
  ItemPricing: '商品単価',
  TotalPriceOfGoods: '商品の合計価格',
  ChinaAdditionalTaxRate: '中国の付加税率',
  ChinasSurtaxTariff: '中国付加税の税務規則',
  ChinaSurtaxClause: '中国付加税条項',
  AccountsReceivableGeneratedSuccessfully: '売掛金が生成されました。',
  PayableExpensesGeneratedSuccessfully: '支払費用の生成に成功しました。',
  ThePleaseConfirmWhetherData: '空にする操作は回復できません。データを空にするかどうかを確認してください。',
  TheSureYouWantData: '削除操作は回復できません。この行のデータを削除するかどうかを確認してください。',
  BusinessDateChangedUpdateExchangeRate: '営業日が変更されました。費用為替レートの更新に注意してください',
  CustomsClearance: 'クリアランス',
  QuantityIsInconsistentOfEqSizeType: '【{eqSize}{eqType}】箱の量と箱詰め情報の数が一緻しません',
  QuantityIsInconsistentOfCodeType: '【{containerCode}{containerType}】箱の量とパレット情報の数が一緻しません',
  syncChargesToExportJobMessage: '合計{total}個の情報を同期し、成功{successCount}個、失敗{failCount}個',
  syncChargesToExportJobFailMessage: '同期{total}条費,成功{successCount}個、失敗{failCount}個,理由は次のとおり',
  ImportReceivablePpayableObjectNotEqualCustomer: '費用{no}:輸入売掛/未収金決済対象！=輸出先（委託先）',
  BillGenerated: '費用{no}:請求書が生成されました',
  InvoiceIssued: '料金{no}:請求済み',
  AccountWrittenOff: '費用{no}:消込済',
  PaymentApplication: '費用{no}:支払済申請',
  ExpenseConfirmationYes: '料金{no}:料金確認-はい',
  ExpenseStatusSubmitted: '費用{no}:費用の状態-提出済み',
  CollectionAdvancePayment: '費用{no}:立て替え払い済み',
  ExpensesGeneratedByVarianceProcessing: '費用{no}:差額処理による費用',
  Shared: '費用{no}:配賦済み',
  NotOperatingCannotSynchronized: '非正操作注文は同期操作ができません',
  ImportHasSynchronizedDispatchingInformation: '輸入注文は配車情報を同期しましたまだ続けますか？',
  MatchingConditionsForPushSOPReceiver: 'SOP受信者の一緻条件をプッシュします',
  GenerateXChargeSyncRecords: '{num}個の費用同期レコードを生成',
  Density: '密度',
  CommissionedDensity: '依頼密度',
  ActualDensity: '実際の密度',
  EstimatedReviewer: 'プレビューレビュー担当者',
  DateOfPreReview: 'レビュー予定日',
  EnteredXNotMatchAirlineCode: '入力されたフライトコード{0}が航空会社のAirlineCodeと一緻しません',
  EnteredXNotMatchAirlinePrefix: '入力されたメインシート番号の最初の3桁{0}が航空会社MAWBPrefixと一緻しません',
  HasPackingFeeEnterWarehouse: '梱包費用があります。倉庫情報を入力してください！',
  SuccessSyncInfo: '同期情報が成功しました',
  Search: 'データ検索',
  Clear: '空にする',
  ShipperName: '出荷者名',
  ConsigneeName: '荷受人の名前',
  NotifyPartyName: '通知先の名前',
  AfterToBeRevokedSynchronize: '同期を確認してから元に戻すことはできません。同期を確認しますか？',
  PleaseADataToDelete: '削除するデータを選択してください！',
  CreatePaymentRequestSelectFee: '支払要求の作成-費用の選択',
  PleaseSelectTheBill: '請求書を選択してください。',
  YouViewOrPrintOthers: '他の人がアップロードまたは印刷したファイルを表示する権限がありません。',
  AgentCommissionBill: '代理店は請求書を分割します',
  TheWithdrawnAndCannotOperated: '業務はすでに終了しており、操作できません',
  PleaseSelectTheForeignBill: '海外の請求書を選択してください。',
  Equivalent: '換算',
  EquivalentToRMB: 'RMBに換算する',
  OperationFailed: '操作に失敗しました',
  FrontEndErrorCallbackFailed: 'フロントエンドerror:コールバック失敗',
  YouToEditTheAdministrator: 'データを編集する権限がありません。管理者に連絡してください',
  UploadingPleaseWait: 'アップロード中です。しばらくお待ちください.',
  AssociateBusinessSOPNode: '関連業務sopノード',
  CustomsDuty: '関税',
  AddAmendmentFee: '新規変更料金',
  AddNewBusiness: '新規ビジネス',
  Add: '新規追加',
  Maintain: '保持する',
  Modify: '変更します',
  PleaseEnterTheBusinessNumber: 'ビジネス番号を入力してください！',
  ReceiptSuccessful: '受領成功',
  WaitingForReceipt: '入荷待ち',
  SaveSuccessfully: '保存に成功しました',
  SendEmail: '送信メールアドレス',
  SystemEmail: 'システムメール',
  CompanyEmail: '会社のメールアドレス',
  PersonalEmail: '個人メールアドレス',
  Submitted: '送信済み',
  DataSource: 'データ取得元',
  SystemInput: 'システム入力',
  PortAreaData: '港区データ',
  UpdateToPortAreaData: '港区データに更新',
  NewExportClearancePolicy: '輸出許可の新しい規則',
  YangshanAreaNovember152021: '洋山関区:2021年11月15日',
  WaigaoqiaoAreaNovember222021: '外港関区:2021年11月22日',
  GarbageManifest: 'ゴミマニフェスト',
  N1OnceTheManifestManifest: '1.ごみの積み荷は税関で厳重に禁止されている。！税関の規定によると、1票ごとに船室の予約書を作成し、実際の出荷貨物に対応しなければならない。船積書類が発送された後、貨物が出荷されていない場合（船に間に合わなかった、出荷計画の変更などの原因）、この船積書類はゴミ船積書類と見なされます！',
  N2ManifestMustBeDeletion: '2.ごみマニフェストの例:船舶が再配置された後、元の積荷目録は必ず削除しなければなりません。削除してから新しい積荷目録を送信することができます。',
  N3YuanOnTheManifest: '3.ゴミマニフェストが削除されなかった場合の結菓:船積みに影響するだけでなく、税関は貨物代に最高50000元の罰金を科し、通関資格を取り消すことができます！ごみマニフェストが表示されたら、すぐにカスタマーサービスに連絡して、ごみマニフェストの削除に協力してください！',
  BusinessUUIDCannotBeEmpty: 'ビジネスUUIDは空にできません！',
  BillUUIDCannotBeEmpty: '請求書のUUIDは空にできません！',
  FileInformation: 'ファイル情報',
  BillingInformation: '請求書情報',
  DomesticWarehouse: '国内倉庫',
  ForeignWarehouse: '海外倉庫',
  ExpectedTimeAtAmazonWarehouse: 'アマゾン倉庫に入る予定時間',
  ReferenceBoxNumber: '参照ボックス番号',
  TotalDoesNotEqualCost: '請求書配分費用の合計は元の費用と等しくありません！',
  NameCannotBeEmpty: '名前は空にできません！',
  SOPOperationStatus: 'SOP操作内容処理状況',
  AddSpecialFees: '特別料金の追加',
  TrailerTrackingUsageNotice: 'トレーラー追跡使用通知書',
  N1SituationIncludingButDepartments: '1.国の関連法律の規定により、システムはユーザーの検索状況を記録する義務があり、（検索したナンバープレート、検索操作者、検索時間）を含むが、これらに限定されず、関係部門が証拠を求める際に相応の証拠を提供することができる。',
  N2ConsentBeforeQueryingCommunication: '2.国の関連法律の規定により、車両の位置を調べる前に必ず車主の同意を得てください。ユーザーは事前に車主と連絡して許可を得て、権利侵害行為を回避しなければなりません。',
  N3TheOwnersConsentConsequences: '3.ユーザーが車の所有者の同意を得ずに車両情報を照会する場合、これによる法的責任はユーザー自身が負うことになります。',
  N4ItToIrrelevantUser: '4.ユーザーが車の所有者の許可を得た場合また、許可された範囲内で情報を使用し、範囲を超えたり、関係のない第三者に漏らしたりしてはならないことにも注意してください。これによる法的責任はユーザー自身が負うことになります。',
  N5SystemCannotGuaranteeResponsibility: '5.外部要因に製限された製御不能性（GPS設備の故障など）、システムは検索結菓が必ず正確であることを保証できず、ユーザーはシステムが検索結菓の正確性に対していかなる責任も負わないことを明確に理解しなければならない。',
  N6BeAwareOfHome: '6.現在、トレーラーの追跡は第三者を通じて行われているため（カモノハシ）が協力して提供するサービスで、ユーザーがサービスを利用する際に第三者があなたの存在を知り、連絡する可能性があります。これは、CargoWare/沃聯之家があなたの資料を漏洩したことによるものではありません。',
  DoNotRemindMeAgain: '次回は通知しない',
  IUnderstoodAndConfirmContinuing: '了解しました。続行を確認します',
  ImportModeTip: 'インポートタイプは修正で、システムはそれぞれ通関番号、箱番号、封号、箱型、箱種によって港区と一緻するデータにマッチングします。\nインポートタイプは保持で、入力したデータが港区のデータに一緻しない場合は、元の入力データになります。',
  NewExportClearancePolicyTip: '上海税関172号令で通行条件を切り替え、「積載マニフェスト」の受領書によって埠頭に海放情報を転送し、お客様が通関が完了した後、自分で積載マニフェストの状態に注目し、異常状況は直ちにカスタマーサービスに連絡して確認してください。その時、箱詰め内の冗長な船荷証券が適時に削除されず、荷下ろしが適時ではなく、放行後の追加注文が規範に合わず、船荷証券データの修正が成功せず、混合注文、船荷証券番号が2年以内に繰り返し使用されると、船積みに影響を与える。第二に、積荷目録が正常に受領された後、積荷目録の修正、削除、または追加が必要な場合は、船代に連絡して積荷目録を削除してから操作を続行する必要があります。',
  Upload0UploadFailed0: 'アップロード成功:{0}個、アップロード失敗:{1}個。',
  CustomerBranchScopeNot: 'The affiliation of the entrusted unit to the branch is incorrect. Please choose again to maintain consistency.',
  BatchInitiateCollaboration: 'Batch initiate collaboration',
  OrderCenterBranchNotAvailable: '{0} is an order receiving branch, but the order receiving branch configuration has not been enabled',
  BatchCollaboration: 'Batch collaboration',
  SuccessCooperateX: 'Successfully collaborated on {0} transactions',
  SuccessCooperateXFailY: 'Successfully collaborated on {0} transactions, failed on {1} transactions. Reason for failure:',
  BusinessIsMaster: 'Business {0} is the main ticket',
  NotBranchCollaborationManageme: 'Business {0} is not a receiving branch, nor does it have the authority to operate company collaboration management',
  OpOfficeNotCooperateBranch: 'Business {0} operating company cannot be a collaborative branch',
  ExistCollaborationBranchRecord: 'Business {0} already has a collaboration record accepting branch {1}',
  EntrustedRecipient: 'Entrusted recipient',
  NoteConsigneeCustomerExportImport: 'Note: When the export "consignee" corresponds to the import "commissioning unit", please ensure that this partner has a "customer" role!!',
  SetAsDefaultExportInfo: 'Set this content as default export information',
  RecipientNotExist: 'The current recipient does not exist',
  ConsigneeCustomerNotExist: 'The current recipient does not have the role of "customer" and cannot be used as a commissioning unit. Please go to the partner module to maintain information and try again',
  CurrencyChangeCheckDiff: 'The Currency has been adjusted to {0}. Please note the decimal places for currencies such as【Prepaid】,【Collect】, and【Other Charge】.',
  InvalidBillCannotConfirm: 'The bill with invalid status cannot be confirmed. Please confirm',
  Reviewed: 'Reviewed',
  ApplicationPayInitiated: 'Application for payment has been initiated',
  NotPrintedState: 'Not in a printed state',
  StatementGenerated: 'Statement generated',
  NotUnapproved: 'Not unapproved',
  BillCannotVoid: '{0} Bill {1} cannot be invalidated, please confirm',
  SwitchHQNotView: 'You have switched to HQ branch and do not have permission to view the details page. You need to return to the list page to check again',
  JumpListPage: 'Jump to List Page',
  WhenDepartmentBranchNewSelection: 'When the department or branch of the sales/documentation/customer service personnel in the business does not match the original document, a new selection is required!',
  OneClickQuery: 'One click query',
  PreSubimtCheckTip: 'Note: Modifications are not allowed after pre submission of business. After all orders have been submitted, you can use the "one click query" button below to query failed orders.',
  SubimtCheckTip: 'Note: After submitting the business, modifications are not allowed. After all orders are completed and submitted, you can use the "one click query" button below to query failed orders.',
  FinanceAuditCheckTip: 'Note: After business review, modifications will not be allowed. After all orders have been reviewed, you can use the "One Click Query" button below to query failed orders.',
  SalesMapping: 'Sales mapping:',
  SalesCargoSalesMap: 'Mapping sales of delegated business to soliciting sales of operational business',
  BusinessRemarks: 'Business remarks',
  InternalEquipmentNote: 'Internal equipment note',
  QuantityWeightCubageConfirmed: 'The hair of the piece has been confirmed',
  DataModifiedHasMergeContinueSave: 'The data was modified by [{0}] on {1} and has been merged for you. Do you want to save it?',
  SyncYongYouNotCancelReview: 'It has been pushed to UFIDA and cannot be cancelled for review',
  PrintByBusinessNumber: 'Print by business number',
  SelectNotBelongToCurBranch: 'The selected documents include transactions that do not belong to the current branch, they cannot be modified!',
  ClickFilePrivew: 'Click on the file name to preview the file',
  PackageDownload: 'Package Download',
  CCPost: 'CCポスト',
  CCYourself: '自分にCCする',
  SaveCcAddresNextDefault: 'このCC投稿を保存してください（次のデフォルトを引き出すために）',
  ForMakingBatchTransferModifications: '業務番号{0}では、チケット情報のみが選択されており、メインチケット情報が選択されていないため、一括転送ができません。対応するメインチケット情報を選択し、必要な修正を行ってください。',
  TherePositionPleaseConfirmSuitable: '<b>{0}</b>ポジションには複数の選択肢があります。現在選ばれている候補者が適切かどうか確認してください。',
  TheWithBusinessStandardsSelection: '<b>{0}</b>のポジションは業務規範に適合していません。再選択してください。',
  PositionReSelectionReminder: 'ポジション再選択のリマインダー',
  LastEmailSentTime: '最終メール送信時間',
  SendVerification: '送信確認',
  BusinessOfTheSelectedMatch: '業務検証例外：選択した業務の{0}が一致しません。',
  FeeReceivable: '費用（未収）',
  CostsPayable: '費用（支払い対象）',
  TheThisBusinessCannotModified: 'この事業の納品先は変更できません。',
  TheLoadingPOLCannotEmpty: '積出港（POL）は空欄にできません。',
  TheForThisShipmentModified: 'この貨物の積出港（POL）は変更できません。',
  TheDestinationCannotBeEmpty: '最終目的地は空にできません。',
  TheThisServiceCannotModified: 'このサービスの最終目的地は変更できません。',
  TheForThisServiceChanged: 'このサービスの積卸し港（POD）は変更できません。',
  TheDischargePODCannotEmpty: '目的港（POD）は空にできません。',
  ShippingTypeCannotBeEmpty: '荷物の種類は空にできません',
  InvalidCargoType: '無効な荷物の種類',
  TheServiceHasBeenModified: 'このサービスの荷物受け入れタイプはロックされており、変更できません。',
  TheForThisServiceModified: 'このサービスの荷物受け入れタイプは変更できません。',
  TheForThisServiceModified2: 'このサービスの商品カテゴリは変更できません。',
  TheIsNotAllowedChanges: '目的港の代理は変更を許可されていません。',
  ListOfHazardousMaterials: '危険物リスト',
  DangerousGoodsInformation: '危険物情報',
  CustomsProcedures: '通関手続き',
  CarDispatchInformation: '車両手配情報',
  QuantityGrossWeightVolume: '数量/総重量/体積',
  CustomFormBusinessBooking: 'カスタムフォーム（業務積載）',
  BusinessOperationInstruction: '[業務操作指令]',
  NonEditable: '編集不可',
  BatchExportToImport: '大量輸出から輸入へ',
  NonSupportImportationThroughEntry: 'グループ会社でない場合、輸出転入はサポートされていません。',
  BatchProcessingForTheReselect: '一括輸出から輸入への変更は、同じ目的港代理店業務のみをチェックして一括処理が可能です。再度選択してください！！',
  TheNotMeetTheConversion: '目的港の代理人および運営会社は、輸出から輸入への転換の条件を満たしていません！',
  TheThePortAgentExist: '目的港代理の連結支店が存在しません。',
  NotForReExport: '再輸出禁止',
  ExportFunctionIsNotEnabled: '輸出転入機能が有効になっていません',
  BatchProgressPleaseReferBelow: '一括出力からインポートへの処理中です。詳細は以下の実行結果をご確認ください。',
  TheDestinationPortAgentEmpty: '目的港代理の接続支社は空であってはなりません！',
  PleaseAFeeToEdit: '編集する費用を選択してください',
  PleaseFeesYouWantDelete: '削除する費用を選択してください。',
  AreWantToDeleteExpense: '選択した費用を削除してもよろしいですか？',
  ThisFeeIsNotEditable: 'この費用は編集できません。',
  TheNameCannotBeEmpty: '費用名は空にできません。',
  BillUpTo3Currencies: '請求書は最大で3通貨までサポートしています！'
}
